<template>
  <b-nav-item>
    <feather-icon
      size="21"
      icon="RefreshCwIcon"
    />
  </b-nav-item>
</template>

<script>
import { BNavItem } from 'bootstrap-vue'

export default {
  components: {
    BNavItem,
  },
  setup() {

  },
}
</script>
